import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.generalPanel.questionAnalysisTable.title',
    defaultMessage: 'Analysis of distractors by issue',
  },
  questions: {
    id: 'reports.generalPanel.questionAnalysisTable.questions',
    defaultMessage: 'Questions',
  },
  discipline: {
    id: 'reports.generalPanel.questionAnalysisTable.discipline',
    defaultMessage: 'Discipline',
  },
  distractorAlternative: {
    id: 'reports.generalPanel.questionAnalysisTable.distractorAlternative',
    defaultMessage: 'Alternative distractor',
  },
  distractorPercentage: {
    id: 'reports.generalPanel.questionAnalysisTable.distractorPercentage',
    defaultMessage: '% of distractor',
  },
  correctAlternative: {
    id: 'reports.generalPanel.questionAnalysisTable.correctAlternative',
    defaultMessage: 'Correct alternative',
  },
  hitPercentage: {
    id: 'reports.generalPanel.questionAnalysisTable.hitPercentage',
    defaultMessage: '% of hits',
  },
  seeMore: {
    id: 'reports.generalPanel.questionAnalysisTable.seeMore',
    defaultMessage: 'See more',
  },
  curricularComponent: {
    id: 'reports.generalPanel.questionAnalysisTable.curricularComponent',
    defaultMessage: 'Curricular Component',
  },
});
